import { useState } from "react";

export default function News() {
  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      <div className="flex-1 flex flex-col">
        <div className="p-8 flex flex-col">
          <div className="bg-white shadow rounded-lg p-4 sm:p-6 text-sm md:mt-0">
            <div className="flex flex-col sm:flex-row justify-between items-center mb-4">
              {/* Add iframe here */}
              <iframe
                src="https://www.marea.com.my/category/press-release/"
                title="ShadCN UI"
                width="100%"
                height="600"
                className="rounded-lg"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
